import { Plus, Trash } from "@phosphor-icons/react";

// Mirrors backend _calc_item: totals are gross (VAT included), locked lines keep stored totals.
export function calcItem(it) {
  const q = Number(it.quantity || 0);
  const p = Number(it.unit_price || 0);
  const r = Number(it.vat_rate || 0);
  let amount, total, dp;
  if (it.locked) {
    amount = Number(it.amount ?? q * p);
    total = Number(it.total || 0);
    dp = amount ? +(((amount - total) / amount) * 100).toFixed(2) : 0;
  } else {
    amount = +(q * p).toFixed(2);
    dp = Number(it.discount_percent || 0);
    total = +(amount * (1 - dp / 100)).toFixed(2);
  }
  const vat = r ? +(total - total / (1 + r / 100)).toFixed(2) : 0;
  return { ...it, quantity: q, unit_price: p, amount, total, discount_percent: dp, discount_amount: +(amount - total).toFixed(2), price_after_discount: q ? +(total / q).toFixed(2) : 0, vat_amount: vat };
}

export function calcTotals(items) {
  const s = (k) => +items.reduce((a, i) => a + Number(i[k] || 0), 0).toFixed(2);
  return { subtotal: s("amount"), discount_total: s("discount_amount"), vat_total: s("vat_amount"), total: s("total") };
}

const NUM = "w-full rounded border border-slate-300 bg-white px-1.5 py-1 text-right text-xs";

function ItemRow({ it, idx, onPatch, onDelete }) {
  return (
    <div className="grid grid-cols-[1fr_64px_88px_64px_56px_28px] items-center gap-1.5">
      <input value={it.description || ""} onChange={(e) => onPatch({ description: e.target.value })} className="rounded border border-slate-300 bg-white px-1.5 py-1 text-xs" placeholder="Opis" data-testid={`inv-item-desc-${idx}`} />
      <input type="number" step="0.5" value={it.quantity} onChange={(e) => onPatch({ quantity: parseFloat(e.target.value) || 0 })} className={NUM} data-testid={`inv-item-qty-${idx}`} />
      <input type="number" step="0.01" value={it.unit_price} onChange={(e) => onPatch({ unit_price: parseFloat(e.target.value) || 0 })} className={NUM} data-testid={`inv-item-price-${idx}`} />
      <input type="number" step="0.1" value={it.discount_percent} onChange={(e) => onPatch({ discount_percent: parseFloat(e.target.value) || 0 })} className={NUM} data-testid={`inv-item-discount-${idx}`} />
      <input type="number" step="0.5" value={it.vat_rate} onChange={(e) => onPatch({ vat_rate: parseFloat(e.target.value) || 0 })} className={NUM} data-testid={`inv-item-vat-${idx}`} />
      <button type="button" onClick={onDelete} className="rounded p-1 text-slate-400 hover:bg-rose-50 hover:text-rose-600" data-testid={`inv-item-del-${idx}`}><Trash size={13} /></button>
    </div>
  );
}

/** Editor for free (non-locked) lines — used for predujam / ponuda drafts. */
export default function InvoiceItemsEditor({ items, onChange }) {
  const patch = (idx, p) => onChange(items.map((it, i) => (i === idx ? calcItem({ ...it, ...p }) : it)));
  const add = () => onChange([...items, calcItem({ description: "", quantity: 1, unit_price: 0, vat_rate: items[0]?.vat_rate || 0, discount_percent: 0 })]);
  return (
    <div className="space-y-1.5 rounded-md border border-slate-200 bg-slate-50 p-3" data-testid="inv-items-editor">
      <div className="grid grid-cols-[1fr_64px_88px_64px_56px_28px] gap-1.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        <span>Usluga</span><span className="text-right">Kol.</span><span className="text-right">Cijena</span><span className="text-right">Popust %</span><span className="text-right">PDV %</span><span />
      </div>
      {items.map((it, idx) => (
        <ItemRow key={idx} it={it} idx={idx} onPatch={(p) => patch(idx, p)} onDelete={() => onChange(items.filter((_, i) => i !== idx))} />
      ))}
      <button type="button" onClick={add} className="mt-1 flex items-center gap-1 rounded bg-slate-800 px-3 py-1 text-[11px] font-semibold text-white hover:bg-slate-700" data-testid="inv-add-item">
        <Plus size={11} weight="bold" /> Dodaj stavku
      </button>
    </div>
  );
}
